export default __webpack_public_path__ + "static/media/kelantan2015A.3405babb.jpg";